var map = {
	"./config": [
		9972
	],
	"./config.ts": [
		9972
	],
	"./defaultConfig": [
		4207,
		207
	],
	"./defaultConfig.ts": [
		4207,
		207
	],
	"./msg2021.interia.pl": [
		9560,
		560
	],
	"./msg2021.interia.pl.ts": [
		9560,
		560
	],
	"./sgp2021.interia.pl": [
		5469,
		469
	],
	"./sgp2021.interia.pl.ts": [
		5469,
		469
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8632;
module.exports = webpackAsyncContext;